<template>
  <el-dialog
    class="new-semester"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="10vh"
    width="960px"
    center
  >
    <div class="content">
      <div class="loading" v-if="loading" v-loading="loading"></div>
      <!-- <div class="detail-box" v-if="!received && loading === false"> -->
      <div class="detail-box" v-if="loading === false">
        <div class="activity-info">
          <h3>福利领取方法 :</h3>
          <ul>
            <li class="info-receive">
              <h4>打卡一</h4>
              <!-- <img src="../../assets/image/newyear2024-receive.png" alt=""> -->
              <img :src="course.avatarUrl" alt="">
              <el-tooltip :content="course.name" placement="top">
                <p>{{course.name}}</p>
              </el-tooltip>
              <div class="activity-btn btn-received" :class="{disabled: received}" @click="receive">{{received ? '已领取' : '立即领取'}}</div>
            </li>
            <li class="info-question">
              <h4>打卡二</h4>
              <img src="../../assets/image/newyear2024-qrcode.png" alt="">
              <p><span>扫码参与调研、</span>填写问卷</p>
              <p>还可获得<span>2024白名单赛事加油包！</span></p>
            </li>
            <li class="info-look">
              <h4>打卡三</h4>
              <div class="info-look-text">
                <p>
                  3月31日前<span>浏览</span>使用《{{course.name}}》<span>课例包≥5次</span>
                </p>
                <p>
                  即可获得教师<span>提升课10课时</span>；
                </p>
              </div>
              <div class="activity-btn btn-look" @click="toCourse">立即浏览</div>
            </li>
          </ul>
          <p class="activity-more">*更多活动详情，请点击首页右上角“平台答疑”扫码加入服务群</p>

          <!-- <h3>精品编程课例包限时开放领取~</h3>
          <ul>
            <li>
              <label>领取时间：</label>
              <span class="orange">9月5日-9月30日</span>
            </li>
            <li>
              <label>领取步骤：</label>
              <div class="step-box">
                <div>
                  <span class="tag">步骤一</span>
                  <p>点击下方<span class="orange">【立即领取】</span>按钮，即可开通活动课例包</p>
                </div>
                <div>
                  <span class="tag">步骤二</span>
                  <p>
                    成功领取后请<span class="orange">扫描</span>提示页面上的<span class="orange"
                      >二维码加入活动群</span
                    >，领取更多编程学习资料
                  </p>
                </div>
                <div>
                  <span class="tag">步骤三</span>
                  <p>
                    关闭弹窗后，可以点击平台右上角的<span class="orange">“助力开学季”</span
                    >按钮再次查看
                  </p>
                </div>
              </div>
            </li>
          </ul> -->
          <!-- <div class="info-detail">
            <div class="detail-l">
              <h3>亲爱的老师</h3>
              <p>新年好！点猫科技为您献上一份厚礼，一起迎接春意盎然的春季新学期！</p>
              <p>敬请加入教师服务群，进群即可领取<span>教育专家直播培训、精品案例资料包、白名单赛事助力包</span>等超丰富的内容及资料</p>
              <p>领取方式：扫码进群，获取更多开学季福利👉 </p>
            </div>
            <div class="detail-r">
              <img src="../../assets/image/newyear-qrcode2024.png" alt="">
              <div class="detail-qr-text">
                <p>扫描二维码</p>
                <p>进群领取开学福利</p>
              </div>
            </div>
          </div> -->
        </div>
        <!-- <div class="course-info" v-if="course">
          <img class="img" :src="course.avatarUrl" />
          <div class="desc">
            <div class="name" :title="course.name">{{ course.name }}</div>
            <span class="count">{{ course.lessonAmount }}个课例</span>
          </div>
        </div> -->
      </div>
      <!-- <el-button
        v-if="!received && loading === false"
        :loading="receiving"
        class="btn-receive"
        type="primary"
        size="medium"
        @click="receive"
        >立即领取</el-button
      > -->
      <!-- <div class="received-box" v-if="received && course && loading === false">
        <icon-success class="icon-success" />
        <h4 class="title">老师您好，《{{ course.name }}》已成功领取！</h4>
        <p>
          请点击<span class="green cursor" @click="toCourse">【课程中心-我的课程】</span>查看吧~
        </p>
        <p>课程有效期至2023年12月31日，请您尽快下载并使用哦~</p>
        <div class="qrcode-box">
          <img class="qrcode" src="@/assets/image/qrcode_new_semester.jpg" />
          <div>
            <h4>请您微信扫描二维码加入服务群</h4>
            <p>领取更多编程学习资料</p>
          </div>
        </div>
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { formatDate } from '@/utils/utils'
import { reportEvent } from '@/utils/sensor'
// import IconSuccess from '@/assets/svg/icon_success.svg'
// import districts from './districts.json'

// 开学季活动时间检查
export function isNewSemester() {
  return moment().isBetween(moment('2024/02/26'), moment('2024/04/01'))
  // && this.user.district_id && !districts.includes(this.user.district_id)
}

export default {
  components: {
    // IconSuccess
  },
  data() {
    return {
      visible: false,
      // visible: true,
      loading: false,
      receiving: false, // 领取中
      received: false, // 已领取
      course: null // 课包信息
    }
  },
  computed: {
    ...mapState(['user']),
    isTeacher() {
      return this.user && (this.user.role_id === 10001 || this.user.role_id === 10002)
    }
  },
  watch: {
    user() {
      this.interceptShow()
    },
    '$route.path'() {
      this.interceptShow()
    },
    isTeacher() {
      this.interceptShow()
    }
  },
  methods: {
    formatDate,
    interceptShow() {
      if (
        this.user &&
        this.user.id &&
        this.isTeacher &&
        this.$route.path === '/dashboard' &&
        this.visible === false
      ) {
        this.show()
      }
    },
    show(force) {
      const showeds = JSON.parse(localStorage.getItem('visibleNewSemester2024Receive') || '[]')
      const showed = showeds.includes(this.user.id)
      if ((force || !showed) && isNewSemester()) {
        this.visible = true
        // this.report('New_Semester_Show', '2024开学季弹窗显示')
        if (!showed) {
          showeds.push(this.user.id)
          localStorage.setItem('visibleNewSemester2024Receive', JSON.stringify(showeds))
        }
        this.fetchPackages()
      }
    },
    // 获取课包列表
    async fetchPackages() {
      this.loading = true
      let receiveStatus = '未领取'
      try {
        const { data } = await API.post('/edu/zone/activity/list/activity/package')
        this.loading = false
        this.course = data[0]
        if (this.course.receivePackage === true) {
          receiveStatus = '已领取'
          this.received = true
        } else {
          this.received = false
        }
      } catch {
        receiveStatus = '请求异常'
        this.loading = false
        this.received = false
      }
      // 埋点统计
      this.report('New_Semester_Show', receiveStatus)
    },
    // 上报
    report(key, status) {
      reportEvent(key, { status })
    },
    async receive() {
      if (this.received) {
        return
      }
      let code = '领取失败'
      try {
        this.receiving = true
        await API.post(
          '/edu/zone/activity/open/package',
          { packageId: this.course.packageId },
          { ignoreMsg: true }
        )
        code = '领取成功'
        this.$message({ type: 'success', message: '课例包领取成功' })
        this.receiving = false
        this.received = true
      } catch (e) {
        code = `请求异常：${e.error_code}`
        this.receiving = false
        this.received = false
        if (e.error_code === 800024) {
          // 课包已领取
          this.fetchPackages()
        } else {
          this.$message.error('领取失败，请稍后重试')
        }
      }
      // 埋点统计
      this.report('New_Semester_Receive', code)
    },
    toCourse() {
      this.visible = false
      sessionStorage.setItem('courseType', 'offical')
      this.$router.push(
        `/courseManage/list/${this.course.packageId}?topicId=${this.course.topicId}&pacakgeEntryType=0`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.new-semester {
  ::v-deep {
    .el-dialog {
      height: 620px;
      background: image-set(
          url(../../assets/image/newyear2024-bg.png) 1x,
          url(../../assets/image/newyear2024-bg@2x.png) 2x
        )
        no-repeat 0 0 / 100% auto;
      box-shadow: none;
    }
    .el-dialog__headerbtn {
      top: 60px;
      right: 20px;
      font-size: 18px;
      .el-dialog__close {
        color: #fff;
        // &:hover {
        //   color: #ff4d4f;
        // }
      }
    }
    .el-dialog__body {
      padding: 0;
      color: #333;
    }
  }
  .content {
    padding: 260px 104px 0 80px;
    .orange {
      color: #ffa21c;
    }
    .green {
      color: #00c4aa;
    }
    .loading {
      height: 280px;
    }
    .cursor {
      cursor: pointer;
    }
    .flex-box {
      display: flex;
      justify-content: space-between;
    }
  }
  .detail-box {
    display: flex;
    align-items: flex-start;
  }
  .activity-info {
    // line-height: 24px;
    color: #333333;
    h3 {
      font-size: 18px;
      font-weight: 500;
    }
    ul {
      margin: 9px 0;
      display: flex;
      justify-content: center;
      li {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 260px;
        height: 234px;
        border-radius: 4px;
        border: 1px solid #E9E1D1;
        h4 {
          width: 161px;
          height: 21px;
          line-height: 21px;
          background: url(../../assets/image/newyear2024-titlebg.png) no-repeat;
          text-align: center;
          color: #ffffff;
          font-size: 12px;
          font-weight: 500;
        }
        p {
          line-height: 20px;
          font-size: 14px;
          span {
            color: #FC3B3B;
          }
        }
        .activity-btn {
          width: 181px;
          height: 32px;
          line-height: 32px;
          background: #FFA21C;
          border-radius: 4px;
          text-align: center;
          color: #ffffff;
          &:hover {
            cursor: pointer
          }
          &.disabled {
            color: #999999;
            background: #EBEBEB;
          }
        }
      }
      li.info-receive {
        img {
          width: 179px;
          height: 128px;
          margin-top: 7px;
        }
        p {
          margin: 4px 0 6px 0;
          font-size: 14px;
          width: 179px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      li.info-question {
        margin: 0 14px;
        img {
          margin: 18px 0 13px 0;
        }
      }
      li.info-look {
        .info-look-text {
          width: 217px;
          margin: 50px auto 40px;
          p:first-child {
            margin-bottom: 15px
          }
        }
      }
    }
    .activity-more {
      color: #999999;
      font-size: 12px;
    }
    // .info-detail {
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   .detail-l {
    //     width: 422px;
    //     h3 {
    //       line-height: 32px;
    //       font-size: 18px;
    //       font-weight: 500;
    //     }
    //     p {
    //       margin-bottom: 20px;
    //       span {
    //         color: #FC3B3B
    //       }
    //     }
    //   }
    //   .detail-r {
    //     margin-left: 40px;
    //     width: 354px;
    //     display: flex;
    //     align-items: center;
    //     img {
    //       width: 140px;
    //       height: 140px;
    //     }
    //     .detail-qr-text {
    //       margin-left: 10px;
    //     }
    //   }
    // }
    // h3 {
    //   line-height: 32px;
    //   font-size: 18px;
    //   font-weight: 500;
    // }
    // li {
    //   display: flex;
    //   margin-top: 10px;
    //   label {
    //     flex: 0 0 75px;
    //     font-weight: bold;
    //   }
    // }
    // p {
    //   font-size: 14px;
    // }
    // .step-box {
    //   div {
    //     margin-bottom: 8px;
    //     &:last-child {
    //       margin-bottom: 0;
    //     }
    //   }
    //   p {
    //     margin-left: 62px;
    //   }
    // }
    // .tag {
    //   float: left;
    //   margin-top: 2px;
    //   padding: 0 8px;
    //   color: #ffa21c;
    //   border: 1px solid #ffa21c;
    //   background: rgba($color: #ffa21c, $alpha: 0.1);
    //   border-radius: 2px;
    //   font-size: 12px;
    //   line-height: 18px;
    // }
  }
  .course-info {
    margin-left: 45px;
    padding: 10px 12px 9px 12px;
    width: 226px;
    background: #fff;
    border: 1px solid #e9e1d1;
    border-radius: 4px;
    .img {
      display: block;
      width: 100%;
      height: 144px;
      border-radius: 4px;
      object-fit: cover;
    }
    .desc {
      display: flex;
      margin-top: 8px;
      overflow: hidden;
    }
    .name {
      flex: 1;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .count {
      display: inline-block;
      margin-top: 2px;
      width: 52px;
      height: 17px;
      line-height: 17px;
      background: #50c690;
      border-radius: 2px;
      color: #fff;
      font-size: 12px;
      text-align: center;
    }
  }
  .btn-receive {
    display: block;
    margin: 25px auto 0;
    padding: 12px 20px;
    width: 174px;
    font-size: 16px;
  }
  .received-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon-success {
      width: 38px;
      height: 38px;
    }
    .title {
      margin-top: 5px;
      color: #52c41a;
      font-size: 18px;
      font-weight: 500;
      line-height: 32px;
    }
    p {
      font-size: 14px;
      line-height: 22px;
    }
  }
  .qrcode-box {
    display: flex;
    margin-top: 20px;
    padding: 10px;
    width: 313px;
    height: 130px;
    background: rgba($color: #e5e5e5, $alpha: 0.18);
    border: 1px solid #dadada;
    border-radius: 8px;
    .qrcode {
      flex: none;
      width: 110px;
      margin-right: 16px;
      object-fit: contain;
    }
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    h4 {
      font-size: 16px;
      line-height: 22px;
    }
    p {
      margin-top: 6px;
      color: #999;
      line-height: 20px;
    }
  }
}
</style>
